module.exports = __webpack_public_path__ + "static/lukas_weisheit-aac5712ba9f638959db3a43aa0287431.jpeg";